/* Lone card on a phone row (James 2026-09-23): "when there are multiple items and an uneven
 * number, the one that's a single item on the line should be centred on mobile."
 * The phone grids are two-across. Which card ends up alone on a row is decided by layout
 * (family leads open fresh rows, story groups flow through display:contents containers,
 * filters hide cards), so this measures the rendered rows instead of counting DOM order and
 * marks a card with no row neighbour as .is-lone; bokja-custom.css centres it at its normal
 * two-across width. A card that already spans the row (a group of one) is left alone.
 * Above 749px every mark is removed. Re-runs on resize and when cards are added or hidden. */
(function () {
  var GRIDS = '.bokja-catgroup__grid, .bokja-storygroup__grid';
  var CARDS = '.bokja-catgroup__item, .bokja-storygroup__item';
  var mq = window.matchMedia('(max-width: 749px)');
  var raf = 0;

  function mark() {
    raf = 0;
    var grids = document.querySelectorAll(GRIDS);
    for (var g = 0; g < grids.length; g++) {
      var grid = grids[g];
      var cards = grid.querySelectorAll(CARDS);
      var i;
      for (i = 0; i < cards.length; i++) cards[i].classList.remove('is-lone');
      if (!mq.matches) continue;
      var gridW = grid.getBoundingClientRect().width;
      var rows = {};
      var order = [];
      for (i = 0; i < cards.length; i++) {
        var c = cards[i];
        if (c.hidden || !c.offsetParent) continue;
        var r = c.getBoundingClientRect();
        if (r.width > gridW * 0.6) continue;           // already full-width by design
        var key = Math.round(r.top);
        if (!rows[key]) { rows[key] = []; order.push(key); }
        rows[key].push(c);
      }
      for (i = 0; i < order.length; i++) {
        var row = rows[order[i]];
        if (row.length === 1) row[0].classList.add('is-lone');
      }
    }
  }
  function schedule() { if (!raf) raf = window.requestAnimationFrame(mark); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  if (mq.addEventListener) mq.addEventListener('change', schedule);
  if (window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        if (m.type === 'childList' || m.attributeName === 'hidden') { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
  }
})();
